import { CalendarDays, Users } from "lucide-react";

const TYPE_OPTIONS = [
  { id: "appointment", label: "One-on-One Appointment", desc: "A private studio fitting", icon: CalendarDays },
  { id: "party", label: "Group Party Booking", desc: "Bridal, birthdays & pop-ups", icon: Users },
];

export function BookingTypeToggle({ value, onChange }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {TYPE_OPTIONS.map((t) => (
        <button
          type="button"
          key={t.id}
          data-testid={`booking-type-${t.id}`}
          aria-pressed={value === t.id}
          onClick={() => onChange(t.id)}
          className={`text-left rounded-2xl border p-4 transition-colors duration-300 ${
            value === t.id ? "border-gold bg-gold/10" : "border-ink/10 hover:border-gold/50"
          }`}
        >
          <t.icon size={18} className={value === t.id ? "text-gold" : "text-stone-400"} />
          <p className="mt-2.5 text-sm font-medium text-ink">{t.label}</p>
          <p className="mt-0.5 text-xs text-stone-500">{t.desc}</p>
        </button>
      ))}
    </div>
  );
}
